
if (!customElements.get('custom-select')) {
    customElements.define(
        "custom-select",
        class CustomSelect extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.details = this.querySelector('details');
                this.summary = this.querySelector('summary');
                this.options = this.querySelectorAll('li');
                this.connectedElement = this.getAttribute('data-connected-element');

                this.summary.addEventListener('click', this.toggle.bind(this));
                this.options.forEach((option) => {
                    option.addEventListener('click', () => {
                        this.select(option);
                        this.toggle();
                    });
                });

                this.checkStoredOption();
                this.handleOutsideClick();
            }

            handleOutsideClick() {
                document.addEventListener('click', (e) => {
                    if (!this.contains(e.target)) {
                        this.details.removeAttribute('open');
                    }
                });
            }

            select(option) {
                this.options.forEach((option) => {
                    option.removeAttribute('data-selected');
                });

                this.summary.querySelector(".selected-option-title").innerHTML = option.innerHTML;
                option.setAttribute('data-selected', 'true');
                
                this.storeOption(this.getAttribute('data-name'), option.dataset.value);

                if (this.connectedElement) {
                    const connectedElement = this.parentElement.querySelector(this.connectedElement);
                    connectedElement.value = option.dataset.value;
                    connectedElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            toggle(e) {
                e && e.preventDefault();
                this.details.open ? this.details.removeAttribute('open') : this.details.setAttribute('open', '');
            }

            getProductHandle() {
                const pathname = window.location.pathname;
                const fullProductHandle = pathname.split('/').pop();
                return fullProductHandle.split('-').slice(0, -1).join('-');
            }

            storeOption(name, value) {
                const productHandle = this.getProductHandle();
                const savedSelectedOption = sessionStorage.getItem(`selectedOption-${productHandle}`);
                const parsedSelectedOption = savedSelectedOption ? JSON.parse(savedSelectedOption) : {};

                const data = {
                    ...parsedSelectedOption,
                    [name]: value
                };
                sessionStorage.setItem(`selectedOption-${productHandle}`, JSON.stringify(data)); 
            }

            checkStoredOption() {
                const productHandle = this.getProductHandle();
                const savedSelectedOption = sessionStorage.getItem(`selectedOption-${productHandle}`);
                const parsedSelectedOption = savedSelectedOption ? JSON.parse(savedSelectedOption) : {};
                const selectedOption = parsedSelectedOption[this.getAttribute('data-name')];

                if (selectedOption) {
                    const option = this.querySelector(`li[data-value="${selectedOption}"]`);
                    if (option) {
                        this.select(option);
                    }
                }
            }
        })
}